import { createFileRoute } from '@tanstack/react-router'

import { useExportOrders } from '@/api/api-mutations'
import { Button } from '@/components/base/button'
import { Drawer } from '@/components/base/drawer'
import { Heading } from '@/components/base/heading'
import { toast } from '@/components/base/toast'
import { FormContainer, FormFieldGroup, useAppForm } from '@/components/form/form'
import { RouteModal, RouteModalFormBlocker, useRouteModal } from '@/components/route-modal'
import { useI18n } from '@/i18n/i18n-react'

export const Route = createFileRoute('/_authenticated/_general/orders/export')({
	component: RouteComponent,
	staticData: {
		crumb: () => 'Export'
	}
})

function RouteComponent() {
	return (
		<RouteModal asDrawer>
			<ExportOrdersForm />
		</RouteModal>
	)
}

function ExportOrdersForm() {
	const { L } = useI18n()
	const { handleSuccess } = useRouteModal()

	const exportOrders = useExportOrders()

	const formatOptions = [
		{ label: 'CSV', value: 'CSV' },
		{ label: 'JSON', value: 'JSON' }
	]

	const form = useAppForm({
		defaultValues: {
			format: 'CSV' as 'CSV' | 'JSON',
			startDate: '',
			endDate: ''
		},
		onSubmit: async ({ value }) => {
			const startTimestamp = value.startDate ? new Date(value.startDate).getTime() : undefined
			const endTimestamp = value.endDate ? new Date(value.endDate).getTime() : undefined

			const result = await exportOrders({
				body: {
					format: value.format,
					startDate: startTimestamp,
					endDate: endTimestamp
				}
			})

			if (result.isSuccess) {
				// Create a download link
				const blob = new Blob([JSON.stringify(result.response)], {
					type: value.format === 'CSV' ? 'text/csv' : 'application/json'
				})
				const url = URL.createObjectURL(blob)
				const a = document.createElement('a')
				a.href = url
				a.download = `orders-export-${Date.now()}.${value.format.toLowerCase()}`
				document.body.appendChild(a)
				a.click()
				document.body.removeChild(a)
				URL.revokeObjectURL(url)

				toast.success('Orders exported successfully')
				handleSuccess()
			} else {
				toast.error(L.Error.SomethingWentWrong())
			}
		}
	})

	return (
		<form.AppForm>
			<RouteModalFormBlocker form={form as any} />
			<Drawer.Header>
				<Drawer.Title asChild>
					<Heading>Export Orders</Heading>
				</Drawer.Title>
			</Drawer.Header>
			<Drawer.Body className='flex-1 overflow-auto'>
				<FormContainer>
					<FormFieldGroup>
						<form.AppField
							name='format'
							children={field => (
								<field.ComboboxField
									label='Format'
									placeholder='Select format'
									options={formatOptions}
								/>
							)}
						/>
					</FormFieldGroup>

					{/* <FormFieldGroup>
								<form.AppField
									name='startDate'
									children={field => (
										<field.TextField
											label='Start Date'
											type='date'
											hint='Leave empty for all orders'
										/>
									)}
								/>
							</FormFieldGroup>

							<FormFieldGroup>
								<form.AppField
									name='endDate'
									children={field => (
										<field.TextField
											label='End Date'
											type='date'
											hint='Leave empty for all orders'
										/>
									)}
								/>
							</FormFieldGroup> */}
				</FormContainer>
			</Drawer.Body>
			<Drawer.Footer>
				<div className='flex items-center justify-end gap-x-2'>
					<Drawer.Close asChild>
						<Button variant='secondary' size='small'>
							{L.General.Cancel()}
						</Button>
					</Drawer.Close>
					<form.SaveButton label='Export' />
				</div>
			</Drawer.Footer>
		</form.AppForm>
	)
}
